const css = `.sidebar::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.sidebar::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar::-webkit-scrollbar-thumb {
  background: transparent;
}

.sidebar,
.mobile-sidebar > .p-sidebar-content {
  overflow-x: hidden;
  width: var(--closed-sidebar-width);
  background-color: var(--surface-raised);
  padding: var(--space-2) var(--space-2);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  will-change: transform, width;
  transform-origin: left;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.sidebar .p-button-icon-only,
.mobile-sidebar > .p-sidebar-content .p-button-icon-only {
  align-self: end;
  color: var(--text-color-secondary);
  border-radius: 50%;
  margin-bottom: var(--space-2);
  width: 40px;
  height: 40px;
  border: unset;
  cursor: pointer;
  background-color: var(--surface-raised);
}
.sidebar .p-button-icon-only span,
.mobile-sidebar > .p-sidebar-content .p-button-icon-only span {
  font-size: var(--font-size-xl);
}
.sidebar .sidebar-image-container,
.mobile-sidebar > .p-sidebar-content .sidebar-image-container {
  display: flex;
  flex-direction: column;
  justify-content: end;
  min-height: 75px;
  align-items: center;
}
.sidebar > ul,
.mobile-sidebar > .p-sidebar-content > ul {
  padding-top: var(--space-3);
  transition: padding 0.5s ease;
}
.sidebar img,
.mobile-sidebar > .p-sidebar-content img {
  border-radius: 100%;
  aspect-ratio: 1;
  width: 40px;
  object-fit: cover;
  transition: width 0.5s ease;
}
.sidebar .sidebar-section-title,
.mobile-sidebar > .p-sidebar-content .sidebar-section-title {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--text);
  text-transform: uppercase;
  margin: var(--space-3) 0;
  opacity: 0;
  width: 0;
  transition: width 0.7s ease, opacity 0.5s ease;
  overflow: hidden;
}
.sidebar .section-divider,
.mobile-sidebar > .p-sidebar-content .section-divider {
  position: absolute;
  top: var(--space-2);
  width: 100%;
  height: 1px;
  background: var(--border);
  opacity: 1;
  transition: opacity 0.7s ease;
}
.sidebar .sidebar-section,
.mobile-sidebar > .p-sidebar-content .sidebar-section {
  position: relative;
}
.sidebar .sidebar-section ul,
.mobile-sidebar > .p-sidebar-content .sidebar-section ul {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.sidebar .sidebar-section ul li,
.mobile-sidebar > .p-sidebar-content .sidebar-section ul li {
  width: 100%;
}
.sidebar .p-button-label,
.mobile-sidebar > .p-sidebar-content .p-button-label {
  width: 0;
  opacity: 0;
  position: absolute;
  left: var(--space-6);
  transition: width 0.7s ease, opacity 0.5s ease !important;
  overflow: hidden;
}
.sidebar.open,
.mobile-sidebar > .p-sidebar-content.open {
  width: var(--sidebar-width);
}
.sidebar.open > ul,
.mobile-sidebar > .p-sidebar-content.open > ul {
  padding-left: var(--space-4);
  padding-right: var(--space-4);
}
.sidebar.open img,
.mobile-sidebar > .p-sidebar-content.open img {
  width: 75px;
}
.sidebar.open .sidebar-section-title,
.mobile-sidebar > .p-sidebar-content.open .sidebar-section-title {
  opacity: 1;
  width: 100%;
}
.sidebar.open .section-divider,
.mobile-sidebar > .p-sidebar-content.open .section-divider {
  opacity: 0;
}
.sidebar.open .sidebar-button,
.mobile-sidebar > .p-sidebar-content.open .sidebar-button {
  padding-left: var(--space-3);
  padding-right: var(--space-3);
}
.sidebar.open .sidebar-button .p-button-label,
.mobile-sidebar > .p-sidebar-content.open .sidebar-button .p-button-label {
  width: 100%;
  opacity: 1;
}
.sidebar.open .sidebar-button .p-badge,
.mobile-sidebar > .p-sidebar-content.open .sidebar-button .p-badge {
  right: var(--space-3);
  top: 50%;
  transform: translateY(-50%);
}

.sidebar {
  height: calc(100vh - env(safe-area-inset-top));
}

@media (min-width: 769px) {
  .sidebar.open {
    position: relative;
  }
  .sidebar.open > .theme-toggle-button {
    position: absolute;
    top: var(--space-2);
    left: var(--space-2);
  }
}
.mobile-sidebar,
.p-sidebar-mask:has(.mobile-sidebar) {
  display: none !important;
}

.mobile-sidebar {
  width: var(--sidebar-width);
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

@media (max-width: 768px) {
  .mobile-sidebar > .p-sidebar-content .theme-toggle-button {
    width: 44px;
    height: 44px;
  }
  .mobile-sidebar,
  .p-sidebar-mask:has(.mobile-sidebar) {
    display: flex !important;
  }
  .mobile-sidebar > .p-sidebar-header {
    display: flex;
    justify-content: flex-end;
    padding: var(--space-4) var(--space-4) 0;
  }
  .mobile-sidebar .theme-toggle-button {
    position: absolute;
    top: 10px;
    left: var(--space-4);
    margin: 0;
  }
  .sidebar {
    z-index: 40;
    position: fixed;
    top: 0;
    margin: 0;
    width: 100%;
    border: 1px solid var(--border);
    border-radius: unset;
    padding: unset;
    flex-direction: row;
    height: var(--navbar-height);
    overflow: hidden;
    transform: none;
    --sidebar-width: 100%;
  }
  .sidebar .sidebar-image-container {
    display: none;
  }
  .sidebar ul {
    display: none;
  }
  .sidebar .p-button-icon-only {
    margin: auto var(--space-4) auto auto;
  }
  .sidebar > .theme-toggle-button {
    display: none;
  }
  .mobile-sidebar > .p-sidebar-content {
    width: 100%;
    padding: var(--space-5);
    margin: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    transform: none;
    will-change: auto;
  }
  .mobile-sidebar > .p-sidebar-content .p-button-label {
    opacity: 1;
    width: unset;
    left: 34px;
    font-size: var(--font-size-base);
  }
  .mobile-sidebar > .p-sidebar-content .sidebar-section-title {
    opacity: 1;
    width: unset;
    font-size: var(--font-size-base);
  }
  .mobile-sidebar > .p-sidebar-content .section-divider {
    display: none;
  }
  .mobile-sidebar > .p-sidebar-content img {
    width: 80px;
    transform: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
